export const skillCategories = [
    {
        category: 'Full-Stack Web Development',
        skills: [
            { name: 'React.js', level: 'Expert' },
            { name: 'Next.js', level: 'Expert' },
            { name: 'SolidJS', level: 'Intermediate' },
            { name: 'Node.js', level: 'Expert' },
            { name: 'Express.js', level: 'Expert' },
            { name: 'HTML', level: 'Expert' },
            { name: 'CSS', level: 'Expert' },
            { name: 'JavaScript', level: 'Expert' },
            { name: 'Bootstrap', level: 'Intermediate' },
            { name: 'REST API', level: 'Expert' },
        ]
    },
    {
        category: 'Artificial Intelligence & Machine Learning',
        skills: [
            { name: 'Python', level: 'Intermediate' },
            { name: 'Machine Learning', level: 'Intermediate' },
            { name: 'LLM Orchestration', level: 'Intermediate' },
            { name: 'Prompt Engineering', level: 'Intermediate' },
            { name: 'RAG (Retrieval-Augmented Generation)', level: 'Intermediate' },
            { name: 'OpenAI API', level: 'Intermediate' },
            { name: 'ElevenLabs', level: 'Intermediate' },
            { name: 'Pydub', level: 'Learning' },
            { name: 'FFmpeg', level: 'Learning' },
            { name: 'AI Podcast Generation', level: 'Intermediate' },
        ]
    },
    {
        category: 'Databases & Backend',
        skills: [
            { name: 'MongoDB', level: 'Expert' },
            { name: 'PostgreSQL', level: 'Intermediate' },
            { name: 'MySQL', level: 'Intermediate' },
            { name: 'PHP', level: 'Intermediate' },
            { name: 'JSP', level: 'Learning' },
            { name: 'JDBC', level: 'Learning' },
        ]
    },
    {
        category: 'DevOps & Deployment',
        skills: [
            { name: 'Git', level: 'Expert' },
            { name: 'GitHub', level: 'Expert' },
            { name: 'Netlify', level: 'Expert' },
            { name: 'Render', level: 'Expert' },
            { name: 'Vercel', level: 'Intermediate' },
            { name: 'QEMU/KVM Virtualization', level: 'Intermediate' },
            { name: 'GitHub Actions CI/CD', level: 'Intermediate' },
            { name: 'Linux VPS Hosting', level: 'Intermediate' },
            { name: 'Shared Hosting', level: 'Expert' },
        ]
    },
    {
        category: 'Programming Languages',
        skills: [
            { name: 'JavaScript', level: 'Expert' },
            { name: 'TypeScript', level: 'Expert' },
            { name: 'Python', level: 'Intermediate' },
            { name: 'Rust', level: 'Intermediate' },
            { name: 'SQL', level: 'Intermediate' },
            { name: 'Java', level: 'Intermediate' },
            { name: 'PHP', level: 'Intermediate' },
            { name: 'C', level: 'Learning' },
        ]
    },
    {
        category: 'Computer Science Fundamentals',
        skills: [
            { name: 'Data Structures & Algorithms', level: 'Intermediate' },
            { name: 'Object-Oriented Programming', level: 'Expert' },
            { name: 'Operating Systems (Linux/Windows)', level: 'Intermediate' },
        ]
    }
];
